<template>
  <div v-if="content" class="accessibility-icon-table">
    <a role="button" href="#" :aria-label="title" :aria-expanded="show ? 'true' : 'false'" @click="show = !show" class="cx-link" style="font-weight: 400" @click.prevent.stop>
      <i class="far fa-question-circle" aria-hidden="true"></i>
      {{ title }}
    </a>
    <article-content-render v-if="show" :presetDetail="content" />
  </div>
</template>

<script>
import axios from 'axios';
import ArticleContentRender from '@/components/ArticleContentRender';

export default {
  name: 'accessibility-icon-table',
  components: {
    ArticleContentRender
  },
  data() {
    return {
      show: false,
      content: null,
    };
  },
  props: {
    title: {
      type: String,
    },
  },
  mounted() {
    axios('/api/article/accessibility/level-icon-list').then(response => {
      this.content = response.data;
    });
  },
};
</script>

<style lang="scss" scoped>
.accessibility-icon-table {
  .cx-link {
    color: $color-green;
  }
}
</style>
